<template>
  <div class="c-led-pcb" v-visible="!loading">
    <img
      class="background"
      :src="images.led_in_switch_65_game_boy"
      @load="onLoad"
    />
    <div class="leds">
      <div
        v-for="LED in LEDs"
        class="led"
        :class="{
          disabled: isPlaying,
        }"
        :key="LED.index"
        :style="LED.style"
        @mousedown.left="
          onMouseDownLeft({ color: frameRGB[LED.index], index: LED.index })
        "
        @mousedown.right="
          onMouseDownRight({ color: frameRGB[LED.index], index: LED.index })
        "
        @mouseenter="
          onMouseEnter({ color: frameRGB[LED.index], index: LED.index }, $event)
        "
        @contextmenu.prevent
      >
        <div class="content">
          <div
            class="background"
            :style="{ backgroundColor: frameRGB[LED.index] }"
          ></div>
          <div
            class="center"
            :style="{
              backgroundColor: frameRGB[LED.index],
              boxShadow:
                (LED.boxShadow || '0 0 0.45rem 0.2rem ') + frameRGB[LED.index],
              opacity: 1 || getLight(frameRGB[LED.index]),
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CLedPcb65GameBoy",
  props: {
    isPlaying: Boolean,
    speed: Number,
    frames: Array,
    frameIndex: Number,
  },
  data() {
    return {
      loading: true,
      playingIndex: 0,
      LEDs: [
        {
          index: 0,
          style: {
            top: "0%",
            left: "0%",
          },
        },
        {
          index: 1,
          style: {
            top: "0%",
            left: "6.4%",
          },
        },
        {
          index: 2,
          style: {
            top: "0%",
            left: "12.8%",
          },
        },
        {
          index: 3,
          style: {
            top: "0%",
            left: "19.2%",
          },
        },
        {
          index: 4,
          style: {
            top: "0%",
            left: "25.6%",
          },
        },
        {
          index: 5,
          style: {
            top: "0%",
            left: "32.0%",
          },
        },
        {
          index: 6,
          style: {
            top: "0%",
            left: "38.3%",
          },
        },
        {
          index: 7,
          style: {
            top: "0%",
            left: "44.6%",
          },
        },
        {
          index: 8,
          style: {
            top: "0%",
            left: "51.0%",
          },
        },
        {
          index: 9,
          style: {
            top: "0%",
            left: "57.4%",
          },
        },
        {
          index: 10,
          style: {
            top: "0%",
            left: "63.7%",
          },
        },
        {
          index: 11,
          style: {
            top: "0%",
            left: "70.1%",
          },
        },
        {
          index: 12,
          style: {
            top: "0%",
            left: "76.5%",
          },
        },
        {
          index: 62,
          style: {
            width: "10.5%",
            top: "0%",
            left: "82.9%",
          },
        },
        {
          index: 13,
          style: {
            top: "0%",
            left: "95.4%",
          },
        },
        {
          index: 14,
          style: {
            width: "7.4%",
            top: "21.1%",
            left: "0%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 15,
          style: {
            top: "21.1%",
            left: "9.7%",
          },
        },
        {
          index: 16,
          style: {
            top: "21.1%",
            left: "16%",
          },
        },
        {
          index: 17,
          style: {
            top: "21.1%",
            left: "22.4%",
          },
        },
        {
          index: 18,
          style: {
            top: "21.1%",
            left: "28.7%",
          },
        },
        {
          index: 19,
          style: {
            top: "21.1%",
            left: "35.1%",
          },
        },
        {
          index: 20,
          style: {
            top: "21.1%",
            left: "41.4%",
          },
        },
        {
          index: 21,
          style: {
            top: "21.1%",
            left: "47.9%",
          },
        },
        {
          index: 22,
          style: {
            top: "21.1%",
            left: "54.2%",
          },
        },
        {
          index: 23,
          style: {
            top: "21.1%",
            left: "60.5%",
          },
        },
        {
          index: 24,
          style: {
            top: "21.1%",
            left: "66.9%",
          },
        },
        {
          index: 25,
          style: {
            top: "21.1%",
            left: "73.2%",
          },
        },
        {
          index: 26,
          style: {
            top: "21.1%",
            left: "79.6%",
          },
        },
        {
          index: 63,
          style: {
            width: "7%",
            top: "21.1%",
            left: "86.3%",
          },
        },
        {
          index: 27,
          style: {
            top: "21.1%",
            left: "95.4%",
          },
        },
        {
          index: 28,
          style: {
            width: "8.8%",
            top: "42.1%",
            left: "0%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 29,
          style: {
            top: "42.1%",
            left: "11.2%",
          },
        },
        {
          index: 30,
          style: {
            top: "42.1%",
            left: "17.6%",
          },
        },
        {
          index: 31,
          style: {
            top: "42.1%",
            left: "24.0%",
          },
        },
        {
          index: 32,
          style: {
            top: "42.1%",
            left: "30.3%",
          },
        },
        {
          index: 33,
          style: {
            top: "42.1%",
            left: "36.6%",
          },
        },
        {
          index: 34,
          style: {
            top: "42.1%",
            left: "43.0%",
          },
        },
        {
          index: 35,
          style: {
            top: "42.1%",
            left: "49.4%",
          },
        },
        {
          index: 36,
          style: {
            top: "42.1%",
            left: "55.7%",
          },
        },
        {
          index: 37,
          style: {
            top: "42.1%",
            left: "62.0%",
          },
        },
        {
          index: 38,
          style: {
            top: "42.1%",
            left: "68.4%",
          },
        },
        {
          index: 39,
          style: {
            top: "42.1%",
            left: "74.8%",
          },
        },
        {
          index: 40,
          style: {
            width: "10.5%",
            top: "42.1%",
            left: "82.1%",
          },
        },
        {
          index: 41,
          style: {
            top: "42.1%",
            left: "95.4%",
          },
        },
        {
          index: 42,
          style: {
            width: "11.6%",
            top: "63.3%",
            left: "0%",
            paddingLeft: "1%",
          },
        },
        {
          index: 43,
          style: {
            top: "63.3%",
            left: "14.4%",
          },
        },
        {
          index: 44,
          style: {
            top: "63.3%",
            left: "20.8%",
          },
        },
        {
          index: 45,
          style: {
            top: "63.3%",
            left: "27.1%",
          },
        },
        {
          index: 46,
          style: {
            top: "63.3%",
            left: "33.5%",
          },
        },
        {
          index: 47,
          style: {
            top: "63.3%",
            left: "39.8%",
          },
        },
        {
          index: 48,
          style: {
            top: "63.3%",
            left: "46.2%",
          },
        },
        {
          index: 49,
          style: {
            top: "63.3%",
            left: "52.5%",
          },
        },
        {
          index: 50,
          style: {
            top: "63.3%",
            left: "59.0%",
          },
        },
        {
          index: 51,
          style: {
            top: "63.3%",
            left: "65.3%",
          },
        },
        {
          index: 52,
          style: {
            top: "63.3%",
            left: "71.7%",
          },
        },
        {
          index: 53,
          style: {
            top: "63.3%",
            left: "80.4%",
          },
        },
        {
          index: 54,
          style: {
            top: "63.3%",
            left: "89.2%",
          },
        },
        {
          index: 55,
          style: {
            top: "63.3%",
            left: "95.4%",
          },
        },
        {
          index: 56,
          style: {
            width: "5.7%",
            top: "84.5%",
            left: "0%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 57,
          style: {
            width: "5.7%",
            top: "84.5%",
            left: "8.1%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 58,
          style: {
            width: "5.7%",
            top: "84.5%",
            left: "16.1%",
            paddingLeft: "0.5%",
          },
        },
        {
          index: 59,
          style: {
            top: "84.5%",
            left: "23.9%",
          },
        },
        {
          index: 61,
          style: {
            top: "84.5%",
            left: "40.6%",
          },
        },
        {
          index: 60,
          style: {
            top: "84.5%",
            left: "57.3%",
          },
        },
        {
          index: 64,
          style: {
            top: "84.5%",
            left: "63.7%",
          },
        },
        {
          index: 65,
          style: {
            top: "84.5%",
            left: "70.0%",
          },
        },
        {
          index: 66,
          style: {
            top: "84.5%",
            left: "76.4%",
          },
        },
        {
          index: 67,
          style: {
            top: "84.5%",
            left: "82.7%",
          },
        },
        {
          index: 68,
          style: {
            top: "84.5%",
            left: "89.1%",
          },
        },
        {
          index: 69,
          style: {
            top: "84.5%",
            left: "95.4%",
          },
        },
      ],
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    frameRGB() {
      if (this.frames) {
        const index = this.isPlaying ? this.playingIndex : this.frameIndex;
        return this.frames[index] ? this.frames[index].frame_RGB : [];
      }
      return [];
    },
  },
  watch: {
    isPlaying: function (isPlaying) {
      if (isPlaying) {
        this.play();
      }
    },
    speed() {
      this.play();
    },
  },
  methods: {
    getLight(hex) {
      const regs = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

      let r = parseInt(regs[1], 16);
      let g = parseInt(regs[2], 16);
      let b = parseInt(regs[3], 16);

      (r /= 255), (g /= 255), (b /= 255);

      const max = Math.max(r, g, b);
      const light = max * 2;
      return light.toFixed(3);
    },
    play() {
      this.playingIndex = 0;
      clearTimeout(this.timer);
      if (this.isPlaying) {
        this.timer = setInterval(() => {
          this.playingIndex = this.playingIndex + 1;
          if (this.playingIndex >= this.frames.length) this.playingIndex = 0;
        }, this.speed);
      }
    },
    onLoad() {
      this.loading = false;
    },
    onMouseDownLeft({ color, index }) {
      this.$emit("led-click", { color, index });
    },
    onMouseDownRight({ index }) {
      this.$emit("led-click-right", { index });
    },
    onMouseEnter({ color, index }, { which, buttons }) {
      if (buttons === undefined ? which === 1 : buttons === 1) {
        this.$emit("led-click", { color, index });
      } else if (buttons === undefined ? which === 3 : buttons === 2) {
        this.$emit("led-click-right", { index, solid: true });
      }
    },
  },
  mounted() {
    if (this.isPlaying) this.play();
  },
};
</script>

<style lang="scss" scoped>
.c-led-pcb {
  width: 100%;
  position: relative;

  .background {
    width: 100%;
    height: auto;
    position: relative;
    -webkit-user-drag: none;
  }

  .leds {
    width: 93.6%;
    height: 54.3%;
    position: absolute;
    left: 3.2%;
    top: 34.6%;

    .led {
      width: 4.5%;
      height: 15.6%;
      padding: 0 0.2%;
      position: absolute;
      cursor: pointer;

      &:hover .content .background {
        // display: block;
      }

      &.disabled {
        background: transparent;
        pointer-events: none;
        cursor: auto;
      }

      .content {
        width: 100%;
        height: 100%;
        position: relative;

        .background {
          width: 100%;
          height: 100%;
          position: absolute;
          display: none;
        }

        .center {
          width: 12px;
          height: 12px;
          left: 50%;
          top: 85%;
          margin-top: -6px;
          margin-left: -6px;
          border-radius: 12px;
          position: absolute;
          filter: brightness(120%);
        }
      }
    }
  }
}
</style>
